export function formatServiceLabel(code: string, description: string | undefined): string {
    return description ? `${code} ${description}` : code;
}
